<template>
  <div class="app-container demo-list">
    <div class="search-wrapper">
      <div class="tab-wrapper">
        <el-button :type="isFocus === 1 ? 'table-top-active' : 'table-top'" size="mini">树形表格模板</el-button>
      </div>
    </div>
    <el-table
      :header-cell-style="{background:'#ffffff',color:'#4A4A4A'}"
      :data="tableData"
      :summary-method="getSummaries"
      style="width: 100%"
      row-key="id"
      show-summary
      border
      class="report multi-header tree-container">
      <el-table-column
        type
        prop="id"
        label="序号"
        width="50"/>
      <el-table-column
        prop="name"
        label="采购单位"/>
      <el-table-column
        prop="date"
        label="订单日期"
        width="130"
      />
      <el-table-column
        prop="type"
        label="类型"
        width="130"
      />
      <el-table-column
        label="电子超市/功能专区"
        prop="number">
        <el-table-column
          prop="weekCount"
          label="订单数量(个)"/>
        <el-table-column
          prop="weekAmount"
          label="协议金额(元)"
          align="right">
          <template slot-scope="scope">
            <span :data-sum="scope.row.weekAmount">{{ scope.row.weekAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="yearAmount"
          label="采购金额(元)"
          align="right"/>
        <el-table-column
          prop="monthAmount"
          label="利润(元)"
          align="right"/>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getData } from '@/api/demo-list-tree'

export default {
  data () {
    return {
      isFocus: 1,
      tableData: []
    }
  },
  watch: {
  },
  created () {
    this.getData()
  },
  mounted () {
  },
  activated () {
  },
  methods: {
    // 数据请求
    getData () {
      const obj = {
        pageSize: 10,
        isShowLoading: true
      }
      getData(obj).then(res => {
        console.log('resresresres', res)
        this.tableData = res.data.data.rows
      }).catch(e => {
        console.log(e)
      })
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            // console.log(value)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          if (index === 4) {
            sums[index] = sums[index]
          } else {
            sums[index] = sums[index].toFixed(2)
          }
        } else {
          sums[index] = '————'
        }
      })
      return sums
    }
  },
  computed: {}
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/variables";

  .demo-list {
    // 本页面的样式写在这里面
    padding-bottom: 20px;
    .el-table{
      margin-top: 30px;
    }
    /deep/ .el-table__footer-wrapper {
      td:nth-child(2), td:nth-child(3), td:nth-child(4) {
        text-align: center;
        color: rgba(241, 241, 241, 1);
      }
    }
    .multifunctional-table-wrapper {
    }
  }
</style>
